module.exports = __webpack_public_path__ + "static/media/stream-default-icon.1b9cd513.png";